import React, { useState, useEffect } from "react";

import OpenPositionsTable from "./OpenPositionsTable";
import OpenOrdersTable from "./OpenOrdersTable";
import OpenPositionsTableNubra from "./OpenPositionTableNubra";
import DashboardLayout from "../DashboardLayout";
import apiClient from "../../utils/apiClient";
import server from "../../utils/serverConfig";

export default function RawOrdersPositions() {
  // State for API data
  const [currentTab, setCurrentTab] = useState("open-orders");
  // State for orders
  const [allOrders, setAllOrders] = useState([]);
  const [isOrdersLoading, setIsOrdersLoading] = useState(false);
  const [ordersError, setOrdersError] = useState(null);

  // State for positions
  const [allPositions, setAllPositions] = useState([]);
  const [isPositionsLoading, setIsPositionsLoading] = useState(false);
  const [positionsError, setPositionsError] = useState(null);

  // State for Nubra Positions
  const [allNubraPositions, setAllNubraPositions] = useState([]);
  const [isNubraPositionsLoading, setIsNubraPositionsLoading] = useState(false);
  const [nubraPositionsError, setNubraPositionsError] = useState(null);

  const [updating, setUpdating] = useState(false);

  const handleChangeTabs = (tabName) => {
    setCurrentTab(tabName);
  };

  // // Fetch positions data
  // const fetchPositionsData = async () => {
  //   try {
  //     const response = await fetch(
  //       "https://godseye.server.sypto.xyz/get_fyers_raw_positions_data"
  //     );

  //     if (!response.ok) {
  //       throw new Error(`Failed to fetch positions data: ${response.status}`);
  //     }

  //     const data = await response.json();
  //     setPositionsData(data);
  //     return data;
  //   } catch (err) {
  //     console.error("Error fetching positions data:", err);
  //     throw err;
  //   }
  // };

  // // Fetch live orders data
  // const fetchLiveOrdersData = async () => {
  //   try {
  //     const response = await fetch(
  //       "https://godseye.server.sypto.xyz/get_fyers_raw_orders_data"
  //     );

  //     if (!response.ok) {
  //       throw new Error(`Failed to fetch data: ${response.status}`);
  //     }

  //     const data = await response.json();
  //     setLiveOrdersData(data);
  //     return data;
  //   } catch (err) {
  //     console.error("Error fetching live orders data:", err);
  //     throw err;
  //   }
  // };

  const fetchOrders = async () => {
    try {
      setIsOrdersLoading(true);
      setOrdersError(null);

      const response = await fetch(
        `${server.godseye.baseUrl}get_fyers_raw_orders_data`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `HTTP ${response.status}: ${response.statusText}${
            errorText ? ` - ${errorText}` : ""
          }`
        );
      }

      const responseText = await response.text();
      const data = JSON.parse(responseText);

      if (data.length > 0) {
        setAllOrders(data);
      } else {
        setAllOrders([]);
      }
    } catch (error) {
      let errorMessage = "Unknown error occurred";
      if (error instanceof Error) {
        errorMessage = error.message;
      }
      setOrdersError(`Failed to fetch orders: ${errorMessage}`);
    } finally {
      setIsOrdersLoading(false);
    }
  };

  const fetchPositions = async () => {
    try {
      setIsPositionsLoading(true);
      setPositionsError(null);

      const response = await fetch(
        `${server.godseye.baseUrl}get_fyers_raw_positions_data`
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `HTTP ${response.status}: ${response.statusText}${
            errorText ? " - " + errorText : ""
          }`
        );
      }

      const data = await response.json();

      setAllPositions(data);
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : String(error);
      setPositionsError(`Failed to fetch positions: ${errorMessage}`);
    } finally {
      setIsPositionsLoading(false);
    }
  };

  const fetchNubraPositions = async () => {
    try {
      setIsPositionsLoading(true);
      setPositionsError(null);

      const response = await fetch(
        `${server.godseye.baseUrl}get_nubra_raw_positions_data`
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `HTTP ${response.status}: ${response.statusText}${
            errorText ? " - " + errorText : ""
          }`
        );
      }

      const data = await response.json();

      setAllNubraPositions(data);
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : String(error);
      setNubraPositionsError(`Failed to fetch positions: ${errorMessage}`);
    } finally {
      setIsNubraPositionsLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
    fetchPositions();
    fetchNubraPositions();
  }, []);

  const updateFyersOrdersData = () => {
    setUpdating(true);
    const url = `${server.godseye.baseUrl}update_fyers_raw_orders_data`;
    const data = {
      secret_key: "cmdev500",
    };

    apiClient
      .post(url, data)
      .then((response) => {
        setUpdating(false);

        if (response.data.message === "updated") {
          fetchOrders();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const updateFyersPositionsData = () => {
    setUpdating(true);
    const url = `${server.godseye.baseUrl}update_fyers_raw_positions_data`;
    const data = {
      secret_key: "cmdev500",
    };

    apiClient
      .post(url, data)
      .then((response) => {
        setUpdating(false);

        if (response.data.message === "updated") {
          fetchPositions();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

   const updateNubraPositionsData = () => {
    setUpdating(true);
    const url = `${server.godseye.baseUrl}update_nubra_raw_positions_data`;
    const data = {
      secret_key: "cmdev500",
    };

    apiClient
      .post(url, data)
      .then((response) => {
        setUpdating(false);

        if (response.data.message === "updated") {
          fetchPositions();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <DashboardLayout>
      <div className="flex flex-col relative  w-full h-screen overflow-hidden">
        <div className="flex flex-col flex-1 h-full">
          <div className=" flex justify-between bg-[#0F0F0F] h-[60px] px-6 w-full">
            <div className="flex space-x-6">
              <div
                onClick={() => handleChangeTabs("open-orders")}
                className={` ${
                  currentTab === "open-orders"
                    ? "text-[#07F2C7]  border-[#07F2C7]"
                    : "border-transparent"
                } flex items-center border-b-[4px]  text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in    `}
              >
                Fyers Open Orders
              </div>
              <div
                onClick={() => handleChangeTabs("positions")}
                className={` ${
                  currentTab === "positions"
                    ? "text-[#07F2C7]  border-[#07F2C7]"
                    : "border-transparent"
                } flex items-center border-b-[4px] text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in  `}
              >
                Fyers Open Positions
              </div>
              <div
                onClick={() => handleChangeTabs("nubra-positions")}
                className={` ${
                  currentTab === "nubra-positions"
                    ? "text-[#07F2C7]  border-[#07F2C7]"
                    : "border-transparent"
                } flex items-center border-b-[4px] text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in  `}
              >
                Nubra Open Positions
              </div>
            </div>
          </div>

          {currentTab === "open-orders" && (
            <OpenOrdersTable
              orders={allOrders}
              isLoading={isOrdersLoading}
              error={ordersError}
              onRefresh={updateFyersOrdersData}
              updating={updating}
            />
          )}

          {currentTab === "positions" && (
            <OpenPositionsTable
              positions={allPositions}
              isLoading={isPositionsLoading}
              error={positionsError}
              onRefresh={updateFyersPositionsData}
              updating={updating}
            />
          )}
          {currentTab === "nubra-positions" && (
            <OpenPositionsTableNubra
              positions={allNubraPositions}
              isLoading={isNubraPositionsLoading}
              error={nubraPositionsError}
              onRefresh={updateNubraPositionsData}
              updating={updating}
            />
          )}
        </div>
      </div>
    </DashboardLayout>
  );
}
